import { FaTh, FaRegChartBar, FaCommentAlt, FaClipboardList, FaBookMedical } from "react-icons/fa";
import { BiImageAdd, BiMap } from "react-icons/bi";

const menu = [
  {
    title: "Dashboard",
    icon: <FaTh />,
    path: "/dashboard",
  },
  {
    title: "Add Product",
    icon: <BiImageAdd />,
    path: "/add-product",
  },
  {
    title: "Account",
    icon: <FaRegChartBar />,
    childrens: [
      {
        title: "Profile",
        path: "/profile",
      },
      {
        title: "Edit Profile",
        path: "/edit-profile",
      },
    ],
  },
  {
    title: "Report Bug",
    icon: <FaCommentAlt />,
    path: "/contact-us",
  },
  {
    title: "Location",
    icon: <BiMap />,
    path: "/map",
  },
  {
    title: "Add Request",
    icon: <FaBookMedical />,
    path: "/add-request",
  },
  {
    title: "Requests",
    icon: <FaClipboardList />,
    path: "/request-list",
  },
];

export default menu;